import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from '../Medias/Logos/logo-wt.png';
import ObjSocialList from './ObjSocialList';

const MainFooter = ({ contents }) => {
  const scrollToTarget = (v_target) => {
    var target = document.getElementById(v_target);
    window.scrollTo({
      top: target.offsetTop - 125,
      behavior: 'smooth'
    });
  }

  return (
    <footer id="footer" className="pt-5 pb-2 bg-color-dark text-white">
      <Container>
        <Row>
          <Col md={4} className='mb-4'>
            <img src={Logo} alt="Logo" className="logo mb-4" />
            <h5>INNOVATIVE LEGAL SOLUTIONS</h5>
            <p>We are a law firm with a reputation for providing result-driven legal services
              to governmental agencies, corporate and individual clients. We are committed
              to understanding our clients’ legal and business requirements by providing
              excellent services and finding innovative result-oriented solutions.</p>
          </Col>
          <Col md={2} className='ps-md-5 mb-4'>
            <h5>Menu</h5>
            <ul className='p-0 m-0' style={{ "listStyleType": "none" }}>
              {/* <li>
                <Nav.Link as={Link} to="/OurFirm" className="text-white text-decoration-none">Our Firm</Nav.Link>
              </li> */}
              <li>
                <Nav.Link as={Link} to="/About" className="text-white text-decoration-none">About Us</Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/OurTeam" className="text-white text-decoration-none">Our Team</Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/OurClient" className="text-white text-decoration-none">Our Clients</Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/Services" className="text-white text-decoration-none">Services</Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/Network" className="text-white text-decoration-none">Our Network</Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/Contact" className="text-white text-decoration-none">Contact Us</Nav.Link>
              </li>
            </ul>
          </Col>
          <Col md={2} className='ps-md-5 mb-4'>
            <h5>Resources</h5>
            <ul className='p-0 m-0' style={{ "listStyleType": "none" }}>
              <li>
                <Nav.Link as={Link} to="/Publication" className="text-white text-decoration-none">Publications</Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/NewsAndEvents" className="text-white text-decoration-none">News &amp; Events</Nav.Link>
              </li>
            </ul>
            <h5 className='mt-4'>Energy Law Center</h5>
            <ul className='p-0 m-0' style={{ "listStyleType": "none" }}>
              <li>
                <Nav.Link as={Link} to="/Regulatory" className="text-white text-decoration-none">Regulatory Updates </Nav.Link>
              </li>
              <li>
                <Nav.Link as={Link} to="/Educational" className="text-white text-decoration-none">Energy Trends</Nav.Link>
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <h5>Contact us</h5>
            <Row>
              <Col>
                <h6>Address</h6>
                {contents?.contact?.address}
              </Col>
              <Col>
                <h6>Email</h6>
                <a href={`mailto:${contents?.contact?.email}`} className='text-white'>{contents?.contact?.email}</a>
                <h6 className='mt-4'>Phone</h6>
                <a href={`tel:${contents?.contact?.phone}`} className='text-white'>{contents?.contact?.phone}</a>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className='mt-5'>
          <Col className="text-center text-white">
            &copy;2025 PT & Associates. All Rights Reserved | 
            <Link to={'/Disclaimer'} className='ms-1 text-white text-decoration-none'>Disclaimer</Link> | 
            <Link to={'/LegalNotice'} className='ms-1 text-white text-decoration-none'>Legal Notice</Link>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

MainFooter.defaultProps = {
  contents: {
    routePath: {
      currentPath: '/'
    }
  }
}

export default MainFooter